import { render, staticRenderFns } from "./SentencePreviewPopover.vue?vue&type=template&id=352c9cc0&scoped=true&"
import script from "./SentencePreviewPopover.vue?vue&type=script&lang=js&"
export * from "./SentencePreviewPopover.vue?vue&type=script&lang=js&"
import style0 from "./SentencePreviewPopover.vue?vue&type=style&index=0&id=352c9cc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352c9cc0",
  null
  
)

export default component.exports